<template>
  <section class="graph-effective-time">
    <HeaderComponent title="Tiempo efectivo por jornada" titlemovil="Tiempo efectivo <br/>por jornada" />
    <div class="graph-effective-time__toolbar">
      <div class="graph-effective-time__toolbar__prom-cont">
        <div class="graph-effective-time__toolbar__prom-cont__title">Promedio</div>
        <div class="graph-effective-time__toolbar__prom-cont__data-cont">
          <span class="graph-effective-time__toolbar__prom-cont__data-cont__var">{{ seasonname }}&nbsp;&nbsp;=</span>
          <span class="graph-effective-time__toolbar__prom-cont__data-cont__value">{{ seasonprom }}</span>
        </div>
      </div>
    </div>
    <div class="graph-effective-time__cont-graph">
      <template v-if="windowWidth < 610 || windowWidth > 1320">
        <Apexchart
          type="line"
          height="310"
          width="610"
          :key="update"
          :options="chartOptions"
          :series="series"
          @markerClick="onMarkerClick"
        ></Apexchart>
      </template>
      <template v-else>
        <Apexchart
          type="line"
          height="310"
          width="99%"
          :key="update"
          :options="chartOptions"
          :series="series"
          @markerClick="onMarkerClick"
        ></Apexchart>
      </template>
    </div>
    <ActiveTimeByMatchDay
      :isVisible="isModalVisible"
      :averages="averages"
      :games="modalGames"
      @close="isModalVisible = false"
    />
  </section>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  name: 'GraphEffectiveTime',
  components: {
    HeaderComponent: () => import('@/components/ActiveTime/Elements/HeaderComponent'),
    Apexchart: () => import('vue-apexcharts'),
    ActiveTimeByMatchDay: () => import('@/components/ActiveTime/Modals/ActiveTimeByMatchDay'),
  },
  props: {
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    seasons: {
      type: Array,
      default: () => [],
    },
  },
  computed: { ...mapState({ windowWidth: 'windowWidth' }) },

  watch: {
    windowWidth() {
      if (this.windowWidth < 610 || this.windowWidth > 1320) {
        if (this.change) {
          this.update += 1;
          this.change = true;
        }
      } else {
        this.change = false;
      }
    },
    seasons: {
      immediate: true,
      deep: true,
      handler: async function(newValue) {
        if (newValue && newValue.length) {
          const season = newValue.filter(season => season.type === 0)[0];
          await this.getTEperMatchday(season.id);
        }
      },
    },
  },
  data() {
    return {
      seasonname: '',
      seasonprom: '',
      url: 'https://i7u9n9i5v4.execute-api.us-east-2.amazonaws.com/prod/te-per-matchday/',
      change: false,
      update: 0,
      widthGraph: 610,
      series: [],
      matchDays: [],
      modalGames: [],
      averages: {},
      isModalVisible: false,
      chartOptions: {
        chart: {
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 0,
            left: 15,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ['#77B6EA', '#545454', '#66d13b', '#008ffb', '#f0ad4e'],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '8px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'Bold',
            colors: ['#132739', '#999'],
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            padding: 5,
            borderRadius: 2,
            borderWidth: 0,
            borderColor: '#fff',
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45,
            },
          },
        },
        stroke: {
          curve: 'smooth',
        },
        title: {
          show: false,
          text: undefined,
          align: 'left',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: [],
          title: {
            show: true,
            text: undefined,
          },
          labels: {
            style: {
              colors: [],
              fontSize: '10px',
            },
          },
        },
        yaxis: {
          title: {
            show: false,
            text: undefined,
          },
          min: 46,
          max: 57,
        },
        legend: {
          // show: true,
          position: 'bottom',
          horizontalAlign: 'right',
          floating: false,
          offsetY: 3,
          offsetX: -5,
        },
      },
    };
  },
  methods: {
    onMarkerClick(_, __, seriesData) {
      const matchDay = this.matchDays[seriesData.dataPointIndex] || {};
      this.modalGames = matchDay.games;
      this.averages = matchDay.average;
      this.isModalVisible = true;
    },
    getMinMaxForLoop(arr) {
      let maximum = arr[0];
      let minimum = arr[0];
      for (let i = 0; i < arr.length; i++) {
        if (maximum < arr[i]) {
          maximum = arr[i];
        } else {
          minimum = arr[i];
        }
      }
      let result = [maximum, minimum];
      return result;
    },
    async getTEperMatchday(season) {
      let s = 1;
      if (this.$route.query.s) {
        if (this.$route.query.s == 1 || this.$route.query.s == 0) {
          s = this.$route.query.s;
        }
      }
      const dataGraph = await axios
        .get(this.url + season + '?s=' + s)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getTEperMatchday(season);
          }
          return e;
        });
      const currentSeason = dataGraph.data[0];
      this.matchDays = currentSeason.matchdays;
      this.seasonname = '-';
      this.seasonprom = '-';
      this.chartOptions.xaxis.categories = [];
      this.chartOptions.yaxis.min = 0;
      this.chartOptions.yaxis.min = 0;
      if (dataGraph.data != '') {
        this.series = [];
        var matchsperseason = {};
        var matchsperseasonnum = [];
        var max = 0;
        var min = 100;
        var maxmatchdays = 0;
        var seasonmax = 0;
        this.seasonname = dataGraph.data[0].season_name;
        this.seasonprom = dataGraph.data[0].season_average;
        for (let indexP = 0; indexP < dataGraph.data.length; indexP++) {
          var objectLine = {
            name: dataGraph.data[indexP].season_name,
            data: [],
          };
          matchsperseason[dataGraph.data[indexP].season_id] = [];
          matchsperseasonnum[indexP] = 0;
          for (let index = 0; index < dataGraph.data[indexP].matchdays.length; index++) {
            objectLine.data.push(dataGraph.data[indexP].matchdays[index].te.replace(':', '.'));
            max =
              dataGraph.data[indexP].matchdays[index].te.replace(':', '.') > max
                ? dataGraph.data[indexP].matchdays[index].te.replace(':', '.')
                : max;
            min =
              dataGraph.data[indexP].matchdays[index].te.replace(':', '.') < min
                ? dataGraph.data[indexP].matchdays[index].te.replace(':', '.')
                : min;
            dataGraph.data[indexP].matchdays[index].matchday_name =
              dataGraph.data[indexP].matchdays[index].matchday_id == 18
                ? 'CFI'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 19
                ? 'CFV'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 20
                ? 'SFI'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 21
                ? 'SFV'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 22
                ? 'FI'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 86
                ? 'FV'
                : dataGraph.data[indexP].matchdays[index].matchday_id == 18000
                ? 'R'
                : dataGraph.data[indexP].matchdays[index].matchday_name.replace('Matchday ', 'J');
            matchsperseason[dataGraph.data[indexP].season_id].push(
              dataGraph.data[indexP].matchdays[index].matchday_name,
            );
            matchsperseasonnum[indexP] += 1;
          }
          if (matchsperseasonnum[indexP] > maxmatchdays) {
            maxmatchdays = matchsperseasonnum[indexP];
            seasonmax = dataGraph.data[indexP].season_id;
          }
          this.series.push(objectLine);
        }
        this.chartOptions.xaxis.categories = matchsperseason[seasonmax];
        const minValue = Number(min) - Number(min) * 0.1;
        const maxValue = Number(max) + Number(max) * 0.1;
        this.chartOptions.yaxis.min = minValue;
        this.chartOptions.yaxis.max = maxValue;
      }
      this.update += 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.graph-effective-time {
  width: 100%;
  height: auto;

  &__toolbar {
    // background: red;
    width: 100%;
    height: 35px;
    display: inline-flex;
    justify-content: center;
    margin-top: 10px;
    &__prom-cont {
      width: 320px;
      height: 35px;
      // background: blue;
      display: inline-flex;
      border-radius: 5px;
      border: 1px solid #132739;
      overflow: hidden;

      @media screen and (max-width: 380px) {
        width: 280px;
      }
      &__title {
        width: 35.5%;
        height: 35px;
        background: #132739;
        line-height: 35px;
        font-size: 15px;
        color: white;
        letter-spacing: -0.26px;
        text-align: center;
        font-family: 'Avenir-Demi';
      }
      &__data-cont {
        width: 62.5%;
        height: 35px;
        // background: rgb(0, 193, 252);
        display: inline-flex;
        justify-content: center;
        align-content: center;
        font-size: 15px;
        align-items: center;
        @media screen and (max-width: 400px) {
          font-size: 13px;
        }
        &__var {
          font-family: 'Avenir-Regular';
        }
        &__value {
          font-family: 'Avenir-Bold';
          margin-left: 5px;
        }
      }
    }
  }
  &__cont-graph {
    width: 100%;
    height: 312px;
    overflow-y: hidden;
    overflow-x: auto;
  }
}
</style>
